import { AddSquareIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { FC } from "react";

interface TemplateButtonProps {
  onClick?: () => void;
}

export const TemplateButton: FC<TemplateButtonProps> = ({ onClick }) => {
  return (
    <div
      className="animate-appear flex min-h-[200px] w-full md:min-w-[340px] max-w-[380px] cursor-pointer flex-col items-center justify-center rounded-lg border border-dashed border-primary-500 bg-primary-20  hover:bg-primary-50"
      onClick={onClick}
    >
      <div className="flex flex-col items-center justify-center gap-2 text-base font-bold text-primary-500">
        {/* <PlusCircle size="24" className="stroke-primary-500" /> */}
        <HugeiconsIcon
          icon={AddSquareIcon}
          className="stroke-primary-500"
          size={24}
        />
        Create template
      </div>
    </div>
  );
};
